import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const LEGALSFOOTERLINKITEMBLOCK_LEGACY_FIELD_ORDER = [
  "name",
  "link",
  "open_in_new_tab"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  legalsFooterLinkItemBlockDescriptor: _generatedLegalsFooterLinkItemBlockDescriptor,
  legalsFooterLinkItemBlockBlocDefinition,
  legalsFooterLinkItemBlockDashboardLayout,
  legalsFooterLinkItemBlockConfig,
  legalsFooterLinkItemBlockResolveConfig,
  legalsFooterLinkItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Legals footer - item link",
    componentType: 'LegalsFooterLinkItemBlockComponent',
    category: 'footer',
    description: "Legals footer - item link.",
    keywords: [],
    allowedIn: [
      { bloc: "LegalsFooterBlockComponent", slot: "links" },
    ],
    sharedFields: {}
  },

  () => ({
    name: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.legals-footer-link-item.name.label",
      }
    }),
    link: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.legals-footer-link-item.link.label",
      }
    }),
    open_in_new_tab: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.legals-footer-link-item.open-in-new-tab.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.legals-footer-link-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.legals-footer-link-item.fieldset.link.label",
            fields: ["name", "link", "open_in_new_tab"],
          },
        ],
      },
    ],
  })
);

export function legalsFooterLinkItemBlockDescriptor(): IBlockDescriptor;
export function legalsFooterLinkItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function legalsFooterLinkItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedLegalsFooterLinkItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedLegalsFooterLinkItemBlockDescriptor, legalsFooterLinkItemBlockProperties, fieldOrder);
}

export {
  legalsFooterLinkItemBlockBlocDefinition,
  legalsFooterLinkItemBlockDashboardLayout,
  legalsFooterLinkItemBlockProperties,
  legalsFooterLinkItemBlockConfig,
  legalsFooterLinkItemBlockResolveConfig,
};

export type LegalsFooterLinkItemBlockConfig = typeof legalsFooterLinkItemBlockConfig;
